import { tab as Devices } from '../main/devices/route.config.ts';
import { tab as Home } from '../main/home/route.config.ts';
import { tab as Mine } from '../main/mine/route.config.ts';
import { tab as Reports } from '../main/reports/route.config.ts';

import type { Tab } from './type.d.ts';

export const tabItems: Tab[] = [Home, Reports, Devices, Mine];
